export const benchmarksActivityOptions = [
  { value: "opens", label: "Opens" },
  { value: "clicks", label: "Clicks" },
  { value: "replies", label: "Replies", default: true },
  { value: "interested", label: "Interested" },
];

export const transformBenchmarksDataForTable = (benchmarksData) => {
  const statKeys = benchmarksData.stats.map((stat) => stat.key);

  const transformedData = benchmarksActivityOptions.map((option) => ({
    name: option.label,
    key: option.value,
    "sw-overall-benchmarks": benchmarksData.overallAverage[option.value],
  }));

  const generateData = (item) => ({
    ...item,
    ...Object.fromEntries(
      statKeys.map((key) => [
        key,
        benchmarksData.stats.find((x) => x.key === key)[item.key],
      ]),
    ),
  });

  return transformedData.map((item) => generateData(item));
};
